import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import {
  OtherDocumentsAccordion,
  RequiredDocumentsAccordion,
} from '../../../components/SupportingDocAccordions';
import content from '../../../utils/content.json';

const Intro = () => (
  <div>
    <p>
      Next we’ll ask you to submit evidence (supporting documents) for your
      claim. If you upload all of this information online now, you may be able
      to get a faster decision on your claim. You can upload documents on the
      next page.
    </p>
  </div>
);

const Documents = props => {
  const { formData } = props;
  return (
    <div>
      <h4 className="vads-u-color--gray-dark">Required documents</h4>
      <RequiredDocumentsAccordion />
      <OtherDocumentsAccordion formData={formData} />
    </div>
  );
};

Documents.propTypes = {
  formData: PropTypes.object,
};

const mapStateToProps = state => ({
  formData: state.form?.data,
});

// ui:description doesn't have access to formData out of the box.
const ConnectedDocuments = connect(mapStateToProps)(Documents);

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['additional-info-supporting-documents-title'], Intro),
    'ui:description': ConnectedDocuments,
  },
  schema: {
    type: 'object',
    properties: {},
  },
};
